export default __webpack_public_path__ + "static/media/location_light_mode.204943b3.svg";